import * as Joi from 'joi';
import _ from 'lodash';
import { CLIENT_STATE_KEYS, TABLE_CLIENT_STATE_KEYS, } from '../../client-state-type';
import { getUpdatedConditionalFormatting } from '../../conditional-formatting-upgrade-util';
import { TableVizPropVersion, } from '../../types/prism';
import { TableClientStateV0Schema } from '../types/v0';
import { TableClientStateV1Class } from '../types/v1';
function getTransformedWidthState(clientState) {
    const widthState = _.get(clientState, TABLE_CLIENT_STATE_KEYS.WIDTH_STATE);
    if (_.isEmpty(widthState)) {
        return [];
    }
    const updatedWidthMap = [];
    Object.keys(widthState).forEach(key => {
        updatedWidthMap.push({
            __typename: 'WidthStateMap',
            columnId: key,
            width: widthState[key] || null,
        });
    });
    return updatedWidthMap;
}
function getUpdatedColumnPropertiesForTable(clientState, vizModel) {
    const columnProperties = _.get(clientState, CLIENT_STATE_KEYS.columnProperties) || {};
    const vizColumn = vizModel.columns;
    const updatedColumnProperties = [];
    _.forEach(vizColumn, col => {
        const tableColumnPropertyMap = {
            __typename: 'TableColumnPropertyMap',
            columnId: col.id,
            columnProperty: {
                __typename: 'TableVizColumnProperties',
                wrapColumnText: _.get(columnProperties, [col.id, TABLE_CLIENT_STATE_KEYS.WRAP_COLUMN_TEXT], null),
                conditionalFormatting: getUpdatedConditionalFormatting(col),
                isHidden: _.get(columnProperties, [col.id, TABLE_CLIENT_STATE_KEYS.IS_HIDDEN], null),
            },
        };
        updatedColumnProperties.push(tableColumnPropertyMap);
    });
    return updatedColumnProperties;
}
function upgradeV0toV1(clientState, tableVizDetail) {
    const tableClientState = _.cloneDeep(clientState);
    const updatedClientState = {
        __typename: 'TableVizProps',
        columnProperties: getUpdatedColumnPropertiesForTable(clientState, tableVizDetail),
        density: null,
        theme: null,
        wrapTableHeader: _.get(tableClientState, TABLE_CLIENT_STATE_KEYS.WRAP_TABLE_HEADER, null),
        widthState: getTransformedWidthState(clientState),
        orderedColumnIds: _.get(tableClientState, TABLE_CLIENT_STATE_KEYS.ORDERED_COLUMN_IDS, []),
        showGridSummary: _.get(tableClientState, TABLE_CLIENT_STATE_KEYS.SHOW_GRID_SUMMARY, null),
        showTableFooter: _.get(tableClientState, TABLE_CLIENT_STATE_KEYS.SHOW_TABLE_FOOTER, null),
        tableVizPropVersion: TableVizPropVersion.V1,
    };
    const newClientState = new TableClientStateV1Class();
    _.assign(newClientState, updatedClientState);
    return newClientState;
}
const upgraderFn = (clientState, vizModel) => {
    Joi.assert(clientState, TableClientStateV0Schema);
    const clientStateVersion = _.get(clientState, CLIENT_STATE_KEYS.version);
    if (!_.isNil(clientStateVersion)) {
        throw new Error(`incompatible client state received in table upgrade path for v0 to v1 with version no:${clientStateVersion}`);
    }
    return upgradeV0toV1(clientState, vizModel);
};
const testHooks = {
    getUpdatedColumnPropertiesForTable,
};
export { upgraderFn, testHooks };
//# sourceMappingURL=v0-to-v1.js.map